import React ,{useEffect}from 'react';
import './style.scss';
import Shape from './shape';
import {Grid} from '@material-ui/core'
import axios from 'axios'
const data = [1 ]

function Index(props) {


  return (
    <Grid container className='p-20 display-flex justify-content-center'>
      {data.map((item, index) => {
       // let className = index % 2 ? ' ml--36' : 'mt-60 ml--36'
        return (
          <>
           <div className='mt-20 mb-20'>
            <Shape text1={props?.blockchain?.fertilizerstatus} text2={props?.blockchain?.fertcert} index={0} className={'mt-60  ml--36'}/>
           </div>
           <div className='mt-20 mb-20'>
            <Shape text1={props?.blockchain?.grading} text2={props?.blockchain?.gradingcert}  index={1} className={'ml--36'}/>
           </div>
            <div className='mt-20 mb-20'>
            <Shape text1={props?.blockchain?.fertilizerstatus} text2={props?.blockchain?.fertcert}  index={2} className={'mt-60  ml--36'}/>
           </div>
           <div className='mt-20 mb-20'>
            <Shape text1={props?.blockchain?.harvestStatus} text2={props?.blockchain?.harvestcert}  index={3} className={'ml--36'}/>
           </div>
            <div className='mt-20 mb-20'>
            <Shape text1={props?.blockchain?.hstart} text2={props?.blockchain?.hcert}  index={4} className={'mt-60  ml--36'}/>
           </div>
           <div className='mt-20 mb-20'>
            <Shape text1={props?.blockchain?.pstused} text2={props?.blockchain?.pstcert}  index={5} className={'ml--36'}/>
           </div>
           </>
        )
      })}
    </Grid>
  );
}

export default Index;
